/**
 * Hover Prefetch - Simple & Robust
 * Preloads pages when user hovers over links for instant navigation
 */

(function() {
  'use strict';

  // Alleen aanwijzen met een fijne pointer start prefetch, ook voor links die
  // later worden ingeladen. Op touch starten we ook geen link-observer.
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  // Configuration
  const HOVER_DELAY = 65; // ms - Start prefetch after 65ms hover (optimal UX)
  const prefetched = new Set(); // Track already prefetched URLs

  // Only prefetch internal links
  function isValidLink(url) {
    try {
      const link = new URL(url, window.location.origin);

      // Must be same origin
      if (link.origin !== window.location.origin) return false;

      // Skip admin, account, cart, checkout
      if (link.pathname.match(/\/(admin|account|cart|checkout)/)) return false;

      // Skip anchor links
      if (link.pathname === window.location.pathname && link.hash) return false;

      // Skip file downloads
      if (link.pathname.match(/\.(pdf|zip|jpg|jpeg|png|gif|svg)$/i)) return false;

      return true;
    } catch (e) {
      return false;
    }
  }

  // Prefetch URL by injecting <link rel="prefetch">
  function prefetchURL(url) {
    // Already prefetched?
    if (prefetched.has(url)) return;

    prefetched.add(url);

    // Create prefetch link
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = url;

    // Add to head
    document.head.appendChild(link);

    console.log('🚀 Prefetching:', url);

    // Clean up after 30 seconds
    setTimeout(() => {
      link.remove();
      prefetched.delete(url);
    }, 30000);
  }

  // Setup hover listener on a link
  function setupHoverListener(link) {
    let hoverTimer = null;

    link.addEventListener('mouseenter', function() {
      const href = this.getAttribute('href');

      if (!href || !isValidLink(href)) return;

      // Wait 65ms before prefetching (avoid accidental hovers)
      hoverTimer = setTimeout(() => {
        prefetchURL(href);
      }, HOVER_DELAY);
    }, { passive: true });

    // Cancel if mouse leaves quickly
    link.addEventListener('mouseleave', function() {
      if (hoverTimer) {
        clearTimeout(hoverTimer);
        hoverTimer = null;
      }
    }, { passive: true });
  }

  // Initialize on all links
  function init() {
    // Get all internal links
    const links = document.querySelectorAll('a[href]');

    links.forEach(link => {
      const href = link.getAttribute('href');
      if (href && isValidLink(href)) {
        setupHoverListener(link);
      }
    });

    console.log(`🔗 Hover prefetch initialized on ${links.length} links`);
  }

  // Also watch for dynamically added links (e.g., in sliders)
  function observeNewLinks() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            if (node.tagName === 'A') {
              const href = node.getAttribute('href');
              if (href && isValidLink(href)) {
                setupHoverListener(node);
              }
            }
            // Check children
            const childLinks = node.querySelectorAll ? node.querySelectorAll('a[href]') : [];
            childLinks.forEach(link => {
              const href = link.getAttribute('href');
              if (href && isValidLink(href)) {
                setupHoverListener(link);
              }
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Watch for new links
  observeNewLinks();

})();
